import { render, staticRenderFns } from "./PriceLuminous.vue?vue&type=template&id=1990a7ba&scoped=true"
import script from "./PriceLuminous.vue?vue&type=script&lang=js"
export * from "./PriceLuminous.vue?vue&type=script&lang=js"
import style0 from "./PriceLuminous.vue?vue&type=style&index=0&id=1990a7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990a7ba",
  null
  
)

export default component.exports